import template from './address-book.html';

const lineList = () => `<ul></ul>`;

const lineItem = () => `<li class="address-book__item"></li>`;

export {
    lineItem,
    lineList
}

export default template;
